import { Snackbar, Alert } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * Renders a custom Snackbar component.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} props.open - Whether the Snackbar is open or not.
 * @param {function} props.onClose - The function to be called when the Snackbar is closed.
 * @param {string} props.vertical - The vertical position of the Snackbar.
 * @param {string} props.horizontal - The horizontal position of the Snackbar.
 * @param {string} props.severity - The severity of the Alert component inside the Snackbar.
 * @param {string} props.variant - The variant of the Alert component inside the Snackbar.
 * @param {string} props.message - The message to be displayed inside the Alert component.
 * @returns {JSX.Element} The rendered MySnackbar component.
 */
const MySnackbar = ({ open, onClose, vertical = 'bottom', horizontal = 'right', severity = 'success', variant = 'filled', message, ...props }) => {

    return (
        <Snackbar
            open={open}
            onClose={onClose}
            autoHideDuration={5000}
            anchorOrigin={{ vertical, horizontal }}
            {...props}
        >
            <Alert onClose={onClose} severity={severity} variant={variant}>
                {message}
            </Alert>
        </Snackbar>
    )
}

MySnackbar.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    vertical: PropTypes.oneOf(['top', 'bottom']),
    horizontal: PropTypes.oneOf(['left', 'center', 'right']),
    severity: PropTypes.oneOf(['warning', 'error', 'info', 'success']),
    variant: PropTypes.oneOf(['filled', 'outlined']),
    message: PropTypes.string.isRequired
}

export { MySnackbar as Snackbar }
